
import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger 
} from "@/components/ui/dropdown-menu";
import { CategoryIcon } from '../../shared/CategoryIcon';
import { TopicType } from '@/types/assistant';
import { TOPIC_CONFIG } from '@/contexts/AiAssistantContext';
import { motion } from 'framer-motion';

interface SidebarHeaderProps {
  onNewSession: (topic: TopicType) => void;
}

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({ 
  onNewSession
}) => {
  return (
    <div className="flex items-center justify-between">
      <h2 className="font-semibold text-lg bg-clip-text text-transparent bg-gradient-to-r from-white to-white/70">
        Conversations
      </h2>
      <div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="sm" className="flex items-center gap-1 bg-gradient-to-r from-primary/90 to-primary/50 text-primary-foreground border-none hover:from-primary hover:to-primary/80 shadow-md shadow-primary/20">
              <Plus size={16} />
              <span>New</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48 backdrop-blur-xl bg-background/70 border-white/20">
            {Object.entries(TOPIC_CONFIG).map(([key, config]) => (
              <DropdownMenuItem 
                key={key} 
                onClick={() => onNewSession(key as TopicType)}
                className="flex items-center gap-2 cursor-pointer hover:bg-white/10"
              >
                <motion.div 
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  className="flex items-center gap-2"
                >
                  <CategoryIcon 
                    category={key as TopicType} 
                    className={config.color}
                  />
                  <span>{config.label}</span>
                </motion.div>
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};
